import React from 'react';
import { Text } from 'src/@vymo/ui/atoms';

export const getIcon = (idx: any, type: any = 'h3') => {
  switch (idx) {
    case 0:
      return <Text type={type}>🥇</Text>;
    case 1:
      return <Text type={type}>🥈</Text>;
    case 2:
      return <Text type={type}>🥉</Text>;
    default:
      return null;
  }
};

export const getRank = (rank) => {
  if (rank <= 3) {
    return getIcon(rank - 1, 'h4');
  }
  return <Text type="h6">{rank}</Text>;
};
